import { render } from "./DashboardActions.vue?vue&type=template&id=c4706c48"
import script from "./DashboardActions.vue?vue&type=script&lang=js"
export * from "./DashboardActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__